import React from "react";

const Footer = () => {
	var d = new Date();
	return (
		<div className="footer out-footer">
			<div className="copyright">
				<p>©2025 
					
					{" "}Trucker Circle.{" "}
					<a target="_blank"  rel="noreferrer">
					 
					</a>{" "}
					 All Rights Reserved
					{/* {d.getFullYear()} */}
				</p>
			</div>
		</div>
	);
};

export default Footer;
 